import { render, staticRenderFns } from "./riskScoreOrderStatistics.vue?vue&type=template&id=701186e5&scoped=true"
import script from "./riskScoreOrderStatistics.vue?vue&type=script&lang=js"
export * from "./riskScoreOrderStatistics.vue?vue&type=script&lang=js"
import style0 from "./riskScoreOrderStatistics.vue?vue&type=style&index=0&id=701186e5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701186e5",
  null
  
)

export default component.exports